import { provideHttpClient, withInterceptors } from "@angular/common/http";
import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter, Router } from "@angular/router";
import { provideAuth0 } from "@auth0/auth0-angular";
import { definePreset } from "@primeuix/themes";
import Lara from "@primeuix/themes/lara";
import * as Sentry from "@sentry/angular";
import { ConfirmationService, MessageService } from "primeng/api";
import { providePrimeNG } from "primeng/config";

import { ApiModule } from "@rr/shared-data-access-api";
import {
  APP_CONFIG,
  httpErrorInterceptor,
  httpHeaderInterceptor,
  httpResponseInterceptor,
} from "@rr/shared-data-access-core";
import { environment } from "../environments";
import { AppInitilizerService } from "./app-initilizer.service";
import { routes } from "./app.routes";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([httpHeaderInterceptor, httpResponseInterceptor, httpErrorInterceptor])),
    providePrimeNG({
      theme: {
        preset: definePreset(Lara),
        options: {
          prefix: "p",
          cssLayer: {
            name: "primeng",
            order: "bootstrap, primeng, app-styles",
          },
          darkModeSelector: ".rr-theme-dark",
        },
      },
      ripple: true,
    }),
    importProvidersFrom(ApiModule.forRoot({ rootUrl: environment.apiUrl })),
    {
      provide: APP_CONFIG,
      useValue: environment,
    },
    provideAuth0(environment.auth0),
    provideAppInitializer(() => {
      const appInitializerService = inject(AppInitilizerService);
      return appInitializerService.initializeApp();
    }),
    MessageService,
    ConfirmationService,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      inject(Sentry.TraceService);
    }),
  ],
};
